import GymSettings from '@/pages/GymSettings';
import ProtectedRoute from '@/components/auth/ProtectedRoute';

export default function GymSettingsPage() {
  return (
    <ProtectedRoute requiredRole="admin">
      <GymSettings />
    </ProtectedRoute>
  );
}